module.exports = __webpack_public_path__ + "media/g-1.ad782727.mp3";